export const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export function todayStr() {
  const today = new Date();
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
}

export function currentMonthStr() {
  const today = new Date();
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
}

export function addDaysStr(dateStr, days) {
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day + days);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function diffDaysStr(fromDate, toDate) {
  if (!fromDate || !toDate) return 0;
  const from = new Date(`${fromDate}T12:00:00`);
  const to = new Date(`${toDate}T12:00:00`);
  return Math.round((to - from) / 86400000);
}

export function monthLabel(month) {
  const [year, monthIndex] = month.split('-').map(Number);
  return `${MONTHS[monthIndex - 1]} ${year}`;
}

export function normalize(value) {
  return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

// Un solo badge por evento. Mientras no arrancó la descarga manda la carga;
// apenas hay un retorno el evento pasa a contarse por la descarga.
// Compartido entre la agenda de escritorio y la de mobile para que no deriven.
export function checklistBadge(event) {
  if (event.descarga_status === 'completed')   return { label: 'Descarga', tone: 'done' };
  if (event.descarga_status === 'in_progress') return { label: 'Descarga', tone: 'progress' };
  switch (event.carga_status) {
    case 'completed':   return { label: 'Carga', tone: 'done' };
    case 'in_progress': return { label: 'Carga', tone: 'progress' };
    case 'pending':     return { label: 'Carga', tone: 'idle' };
    default:            return { label: 'Carga', tone: 'empty' };
  }
}

// Nombre visible de armados y desarmados. Estaba duplicado en tres archivos y
// cada vista armaba el título a su manera: la de mobile no miraba sheet_name,
// así que los armados de planilla sin evento vinculado perdían el nombre entero
// y se veían como un genérico "Armado".
export function operationBaseEventName(name) {
  return String(name || '')
    .trim()
    .replace(/\s+-\s+D[ií]a\s+\d+(?:\s*-\s*\d+)?$/i, '')
    .trim();
}

export function cleanVisibleOperationTitle(title) {
  return String(title || '')
    .trim()
    .replace(/\s+-\s+D[ií]a\s+\d+\s+de\s+1$/i, '')
    .replace(/\s+-\s+D[ií]a\s+\d+\s*-\s*\d+$/i, '')
    .trim();
}

// Nombre visible de un armado o desarmado. Cadena vacía si no tiene ninguno.
export function operationName(item) {
  const propio = String(item?.title || '').trim();
  if ((item?.is_operation || item?.entity_type === 'operation') && propio) {
    return cleanVisibleOperationTitle(propio);
  }
  // Derivado del evento: el prefijo lo ponemos nosotros, porque el nombre del
  // evento no lo trae. En sheet_name, en cambio, ya viene escrito en el texto
  // de la planilla ("Armado Congreso X"), así que ahí no se agrega.
  const evento = String(item?.event_name || '').trim();
  if (evento) {
    const prefijo = item?.type === 'desarmado' ? 'Desarmado' : 'Armado';
    return `${prefijo} ${operationBaseEventName(evento)}`;
  }
  return String(item?.sheet_name || '').trim();
}
